import React from 'react';
import { TextWrapper, Wrapper } from './ConfigurationForm.Styles';
import { CustomAutoCompleteField } from '../../commons/CustomAutoCompleteField';
import { CustomTextField } from '../../commons/CustomTextField';
import { MenuItem } from '@material-ui/core';
export var ConfigurationForm = function (_a) {
    var contactLists = _a.contactLists, readOnly = _a.readOnly;
    return (React.createElement(Wrapper, null,
        React.createElement(TextWrapper, null,
            React.createElement(CustomAutoCompleteField, { disabled: readOnly, options: (contactLists === null || contactLists === void 0 ? void 0 : contactLists.map(function (_a) {
                    var id = _a.id, ContactListConfigName = _a.ContactListConfigName, ContactListTable = _a.ContactListTable;
                    return ({
                        label: "" + ContactListConfigName,
                        value: ContactListTable
                    });
                })) || [], name: 'tableCL', label: 'Contact List', placeholder: 'Please Select', fullWidth: true }),
            React.createElement(CustomTextField, { disabled: readOnly, name: 'filterType', label: 'Filter Type', select: true, fullWidth: true },
                React.createElement(MenuItem, { value: 'none', disabled: true, hidden: true }, "Please Select"),
                React.createElement(MenuItem, { value: 'contact' }, "Contact"),
                React.createElement(MenuItem, { value: 'phone' }, "Phone"))),
        React.createElement(TextWrapper, null,
            React.createElement(CustomTextField, { disabled: readOnly, name: 'filterOrSort', label: 'Filter or Sort', select: true, fullWidth: true },
                React.createElement(MenuItem, { value: 'none', disabled: true, hidden: true }, "Please Select"),
                React.createElement(MenuItem, { value: 'filter' }, "Filter"),
                React.createElement(MenuItem, { value: 'sort' }, "Sort")))));
};
ConfigurationForm.defaultProps = {};
//# sourceMappingURL=ConfigurationForm.js.map